import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "holiday-banner"
}

import { computed } from "vue";


export default {
  __name: 'HolidayBanner',
  props: {
	holidays: {
		type: Object,
		default: () => ({}),
	},
	currentDate: {
		type: String,
		default: () => new Date().toISOString().split("T")[0],
	},
},
  setup(__props) {

const props = __props;

const holidayName = computed(() => {
	if (!props.holidays || !props.currentDate) return null;
	return props.holidays[props.currentDate] || null;
});

return (_ctx, _cache) => {
  return (holidayName.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("i", { class: "fas fa-calendar-day me-1" }, null, -1 /* CACHED */)),
        _createElementVNode("span", null, _toDisplayString(holidayName.value), 1 /* TEXT */)
      ]))
    : _createCommentVNode("v-if", true)
}
}

}